import React from "react";
import SectionHeaderRow from "./SectionHeaderRow";

const FieldGroup = ({
  header,
  headerPath,
  onChangeHeader,
  onDeleteHeader,
  children,
  hasError,
}) => (
  <div
    style={{
      border: hasError
        ? "1px solid #ff4d4f"
        : "1px solid var(--drf-primary-border)",
      borderRadius: 8,
      background: "#ffffff",
      overflow: "hidden",
    }}
  >
    <SectionHeaderRow
      field={header}
      basePath={headerPath}
      onChange={onChangeHeader}
      onDelete={onDeleteHeader}
      embedded
      hasContent={Boolean(children) && React.Children.count(children) > 0}
    />
    {children && (
      <div
        style={{
          padding: 12,
          display: "flex",
          flexDirection: "column",
          gap: 10,
        }}
      >
        {children}
      </div>
    )}
  </div>
);

export default FieldGroup;
